<template>
    <ui-modal
        :name="$mx_getModalName"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        :show-close-option="showCloseOption"
        :title="titleModal"
        icon="fal fa-calendar-alt"
        size="xs"
    >
        <div class="modal-content">
            <template v-if="setCustomChangeOpition">
                <ui-sponsor-selector v-if="canSelectSponsor" v-model="form.data.sponsor" />
                <ui-deal-selector v-model="form.data.customer" :data="form.data.sponsor" />
            </template>

            <ui-input v-model="form.data.taskTitle" label="Título" type="text" size="md" />

            <ui-text-with-select-area title="Observações:">
                <template #select>
                    <ui-select-2
                        v-model="form.data.taskType"
                        item-label="label"
                        return-value="value"
                        placeholder="Tipo"
                        size="xs"
                        design="mgb-0"
                        :search="false"
                        :data="taskTypeOptions"
                        :show-footer="false"
                        :loading="loader.taskTypeLoad"
                    />
                </template>
                <template #text>
                    <textarea
                        v-model="form.data.taskNote"
                        placeholder="Digite..."
                        rows="3"
                    />
                </template>
            </ui-text-with-select-area>

            <div class="time-values">
                <div class="time-value date">
                    <ui-datepicker
                        v-model="form.data.taskDate"
						:context="'today'"
                        groupicon="fal fa-calendar-alt"
                        type="date"
                        size="xs"
                    />
                </div>

                <div class="time-value time">
                    <ui-input
                        v-model="form.data.taskHour"
                        groupicon="fal fa-clock"
                        type="time"
                        size="xs"
                    />
                </div>
            </div>

            <ui-switch
                v-if="canWatch"
                id="manager-can-watch-task"
                v-model="form.data.watch"
                :checked="form.data.status"
                label="Acompanhar tarefa"
                name="watch"
                design="xs primary"
            />
        </div>

        <template #footer>
            <div class="cancel-buttons">
                <ui-modal-cancel-button v-if="showCloseOption" :modal-name="$mx_getModalName" :track-event="gtm.cancel"
                >Cancelar</ui-modal-cancel-button
                >
                <ui-button v-else :track-event="gtm.cancel" type="button" design="md link cancel-button" @click="customCancel">
                    Cancelar
                </ui-button>
            </div>
            <ui-button
                :disabled="!canSubmit"
                type="button"
                design="md success mw-100"
                @click="submit"
            >Salvar</ui-button
            >
        </template>
    </ui-modal>
</template>

<script>
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSelect2, uiSwitch, uiInput, uiTextWithSelectArea, uiDatepicker } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSponsorSelector, uiDealSelector } from '@/components/ui-facilita/selectors'

	import { storage } from '@/services/storage'
	import { phoneMask } from '@/filters'

	import { task } from '@/services/axios'

	import { mapGetters } from 'vuex'
	import { helpersMixin, loaderMixin, alertMixin, modalMixin } from '@/mixins'

	import { defaultGtm } from './default'

	const moment = require('moment')
	require('moment/locale/pt-br')

	const defaultData = {
		id: null,
		sponsor: null,
		customer: null,
		taskTitle: '',
		taskNote: '',
		taskType: null,
		taskDate: null,
		taskHour: null,
		watch: false,
		status: false,
	}

	const defaultLoader = {
		modalLoad: false,
		modalLoadSuccess: false,
		taskTypeLoad: false,
	}

	export default {
		components: {
			uiModal,
			uiModalCancelButton,
			uiSelect2,
			uiButton,
			uiInput,
			uiTextWithSelectArea,
			uiSponsorSelector,
			uiDealSelector,
			uiSwitch,
			uiDatepicker
		},

		filters: {
			phoneMask,
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, modalMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
			clientReason: {
				type: Boolean,
				default: false,
			},
			customerChangeOption: {
				type: Boolean,
				default: false,
			},
			showCloseOption: {
				type: Boolean,
				default: true,
				required: false,
			},
			customCloseEvent: {
				type: [String, Array],
				required: false,
				default: ''
			},
		},

		data() {
			return {
				layout: {
					customerText: ['phone', 'cpf', 'product'],
				},
				setCustomChangeOpition: this.customerChangeOption,
				globalCustomerChangeOpition: null,
				form: {
					fields: {
						sponsor: {
							label: 'Responsável',
							required: true,
							disabled: false,
						},
						customer: {
							label: 'Cliente',
							required: true,
							disabled: false,
						},
						taskType: {
							label: 'Tipo da tarefa',
							required: true,
							disabled: false,
						},
					},
					data: { ...defaultData },
				},
				names: {
					admin: storage.get('label_admin'),
					collaborator: storage.get('label_collaborator'),
					supervisor: storage.get('label_supervisor'),
					manager: storage.get('label_manager'),
					broker: storage.get('label_broker'),
				},
				staticValues: {
					sponsor: {
						name: '',
						id: 0,
					},
					customer: {
						name: '',
						id: 0,
					},
				},
				loader: { ...defaultLoader },
				customerOptions: [],
				taskTypeOptions: [],
				sponsorOptions: [],
				iframe: false,
				userList: [],
				gtm: { ...defaultGtm() }
			}
		},
		computed: {
			...mapGetters('auth', {
				user: 'getUser',
			}),

			titleModal() {
				const id = this.form.data.id ? ' – #' + this.form.data.id : ''
				return 'Criar Tarefa' + id
			},

			canSelectSponsor() {
				return this.user.user_group !== 'broker'
			},

			/**
			 * Condicional que permite o envio do formulário.
			 */
			canSubmit() {
				const form = this.form.data
				let error = form.taskTitle && form.taskType && form.taskDate && form.taskHour

				if (this.globalCustomerChangeOpition || this.setCustomChangeOpition) {
					error =
						error &&
						(this.user.user_group !== 'broker' ? form.sponsor : this.user.id) &&
						form.customer
				} else {
					error = error && this.staticValues.sponsor.id && this.staticValues.customer.id
				}

				return error
			},

			validateDealFormData() {
				let form = this.form.data
				let formData = {
					type: form.taskType,
					notes: form.taskNote,
					title: form.taskTitle,
					for_date: form.taskDate,
					for_hour: form.taskHour,
					deal_linked: null,
					users_assign: [],
					can_owner: true,
					alerts: [
						{
							mode: 'minute',
							interval: 1,
						},
					],
				}

				if (this.setCustomChangeOpition) {
					formData.deal_linked = form.customer
				} else {
					formData.deal_linked = this.staticValues.customer.id
				}

				let usersAssign = {
					user_id: null,
					mode: 'owner',
				}

				if (this.user.user_group === 'broker') {
					usersAssign.user_id = this.user.id
				} else {
					if (this.setCustomChangeOpition) {
						usersAssign.user_id = form.sponsor.id
					} else {
						usersAssign.user_id = this.staticValues.sponsor.id
					}
				}

				formData.users_assign.push(usersAssign)

				// Caso seja manager e aceite acompanhar a tarefa.
				// Adiciona o mesmo como watcher da tarefa.
				if (form.watch) {
					formData.users_assign.push({
						user_id: this.user.id,
						mode: 'watcher',
					})
				}

				return formData
			},

			canEditSponsor() {
				return this.user?.user_group !== 'broker' && this.sponsorOptions.length > 1
			},

			canWatch() {
				if (this.setCustomChangeOpition) return false
				if (!this.staticValues.sponsor) return false

				let canwatch = true

				if (this.form.data.sponsor && this.form.data.sponsor.id === this.user?.id) {
					canwatch = false
				}

				if (this.staticValues.sponsor && this.staticValues.sponsor.id === this.user?.id) {
					canwatch = false
				}

				return this.user?.user_group === 'manager' && canwatch
			},
		},


		mounted() {
			this.$root.$on('modal-open-' + this.$mx_getModalName, async (data, customer, iframe) => {
				this.reset()
				this.iframe = iframe ? iframe : false;
				if (customer) this.globalCustomerChangeOpition = customer
				if (data) {
					this.funcSetCustomChangeOpition(false)
					this.staticValues.sponsor.name = data.user_name
					this.staticValues.sponsor.id = data.user_id

					if (data.manager_name && data.manager_id) {
						this.staticValues.sponsor.name = data.manager_name
						this.staticValues.sponsor.id = data.manager_user_id
						this.createSponsorOptions(
							data.manager_name,
							data.manager_user_id,
							'Gerente',
						)
					}

					if (data.broker_id && data.broker_name) {
						this.staticValues.sponsor.name = data.broker_name
						this.staticValues.sponsor.id = data.broker_user_id
						this.createSponsorOptions(data.broker_name, data.broker_user_id, 'Corretor')
					}

					this.staticValues.customer.name = data.id + ' - ' + data.customer_name
					this.staticValues.customer.id = data.id
					this.form.data.id = data.id
				} else {
					this.funcSetCustomChangeOpition(true)	
				}

				this.form.data.taskDate = moment().format('YYYY-MM-DD')
				this.form.data.taskHour = moment().format('LT')

				this.userList = []

				await this.loadForm()
			})
			window.addEventListener("keydown", event => {
				if(event.keyCode == 27) {
					this.customCancel()
				}
			})
		},

		beforeDestroy() {
			this.closeModal()
			this.$root.$off('modal-open-' + this.$mx_getModalName)
		},

		
		methods: {
			funcSetCustomChangeOpition(val) {
				this.setCustomChangeOpition = val
			},
			/**
			 * Reseta as listas de Responsáveis e Clientes.
			 */
			reset() {
				this.sponsorOptions = []
				this.$set(this.form, 'data', { ...defaultData })
				this.loader = { ...defaultLoader }
			},

			customCancel() {
				if (this.$route.name == 'tasks' || this.iframe) {
					const event = new CustomEvent('iframe--request-modal')
					window.parent.document.dispatchEvent(event)
				}
				if (this.showCloseOption) {
					if (this.customCloseEvent) {
						this.customCloseModal()
						this.closeModal()
						return
					}

					this.closeModal()
					this.reloadTablePage()
				} else {
					if (this.customCloseEvent) {
						this.customCloseModal()
						this.closeModal()
						return
					}

					this.goBack()
				}
			},

			customCloseModal() {
				this.reset()
				if (this.customCloseEvent) {
					if (Array.isArray(this.customCloseEvent)) {
						this.customCloseEvent.forEach((event) => {
							this.$root.$emit('create-task-' + event)
						})

						return
					}

					this.$root.$emit('create-task-' + this.customCloseEvent)
				}
			},

			closeModal() {
				this.$root.$emit('modal-close-' + this.$mx_getModalName)

				if (this.fullPage) this.$router.go(-1)
			},

			/**
			 * Envia o Formulário caso a conicional esteja atendida.
			 */
			submit() {
				if (!this.canSubmit) return
				this.$mx_setLoader('modalLoad', true)

				task.create('', { ...this.validateDealFormData })
					.then((response) => {
						if (response.data.status === 'success') {
							setTimeout(() => {
								this.$mx_setLoader('modalLoadSuccess', true)
								setTimeout(() => {
									this.customCancel()
								}, 1000)
							}, 500)
							this.$gtm.trackEvent(this.gtm.submit)
						} else {
							this.$mx_alertThisOnError(response.data.msg)
							this.$mx_setLoader('modalLoad', false)
						}
					})
					.catch((error) => {
						this.$mx_alertThisOnError(error)
						this.$mx_setLoader('modalLoad', false)
					})
			},

			async loadForm() {
				if (!this.taskTypeOptions.length) {
					this.$mx_setLoader('taskTypeLoad', true)
					const response = await task.getAll('types', null)
					this.taskTypeOptions = response.data[0].fields
					this.$mx_setLoader('taskTypeLoad', false)
				}

				if (this.setCustomChangeOpition) {
					if (this.user.user_group === 'broker') {
						this.form.data.sponsor = {
							group: this.user.group,
							id: this.user.broker_id,
						}
					}
				}
			},

			goBack() {
				this.$router.go(-1)
			},

			createSponsorOptions(name, id, text) {
				this.sponsorOptions.push({
					name: name,
					id: id,
					text: text + ' Responsável',
				})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
